export default function setupEventsCalendarLayout() {
  const calendar = document.querySelector('.events-calendar');
  const weeks = calendar?.querySelectorAll('.events-calendar__week');

  if (!calendar || !weeks?.length) {
    return;
  }

  const getNumericVar = (name, fallback) => {
    const raw = window.getComputedStyle(calendar).getPropertyValue(name).trim();
    const parsed = Number.parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const barRowHeight = getNumericVar('--events-bar-row-height', 34);
  const barRowGap = getNumericVar('--events-bar-row-gap', 6);
  const minimumDayHeight = 180;

  const layoutWeek = (week) => {
    const grid = week.querySelector('.events-calendar__grid');
    const bars = week.querySelector('.events-calendar__bars');
    const days = week.querySelectorAll('.events-calendar__day');

    if (!grid || !days.length) {
      return;
    }

    days.forEach((day) => {
      day.style.minHeight = '';
    });

    const tallestDay = Array.from(days).reduce((height, day) => Math.max(height, day.offsetHeight), minimumDayHeight);
    const barRows = bars ? bars.querySelectorAll('.events-calendar__bar-row').length : 0;
    const barsHeight = barRows > 0 ? (barRows * barRowHeight) + ((barRows - 1) * barRowGap) : 0;
    const targetDayHeight = Math.max(minimumDayHeight, tallestDay, barsHeight + minimumDayHeight);

    days.forEach((day) => {
      day.style.minHeight = `${targetDayHeight}px`;
    });

    week.style.setProperty('--events-bar-rows', String(barRows));
  };

  const layoutAllWeeks = () => {
    weeks.forEach((week) => layoutWeek(week));
  };

  const positionTooltip = (trigger) => {
    const tooltip = trigger.querySelector('.events-calendar__tooltip');

    if (!tooltip) {
      return;
    }

    trigger.classList.remove('events-calendar__event--tooltip-above', 'events-calendar__event--tooltip-below');
    trigger.classList.remove('events-calendar__bar--tooltip-above', 'events-calendar__bar--tooltip-below');

    const triggerRect = trigger.getBoundingClientRect();
    const tooltipHeight = tooltip.offsetHeight;
    const viewportPadding = 16;
    const spaceBelow = window.innerHeight - triggerRect.bottom;
    const spaceAbove = triggerRect.top;
    const shouldShowAbove = spaceBelow < tooltipHeight + viewportPadding && spaceAbove > spaceBelow;
    const prefix = trigger.classList.contains('events-calendar__bar') ? 'events-calendar__bar' : 'events-calendar__event';

    trigger.classList.add(`${prefix}--tooltip-${shouldShowAbove ? 'above' : 'below'}`);
    trigger.closest('.events-calendar__week')?.classList.add('events-calendar__week--tooltip-active');
  };

  const clearTooltip = (trigger) => {
    trigger.closest('.events-calendar__week')?.classList.remove('events-calendar__week--tooltip-active');
  };

  const setupTooltips = () => {
    calendar.querySelectorAll('.events-calendar__event, .events-calendar__bar').forEach((trigger) => {
      trigger.addEventListener('pointerenter', () => positionTooltip(trigger));
      trigger.addEventListener('pointerleave', () => clearTooltip(trigger));
      trigger.addEventListener('focusin', () => positionTooltip(trigger));
      trigger.addEventListener('focusout', () => clearTooltip(trigger));
    });
  };

  layoutAllWeeks();
  setupTooltips();

  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(() => {
      window.requestAnimationFrame(layoutAllWeeks);
    });

    observer.observe(calendar);
    weeks.forEach((week) => observer.observe(week));
  } else {
    window.addEventListener('resize', layoutAllWeeks);
  }
}
